import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarStateService {
  private collapsedSubject = new BehaviorSubject<boolean>(false);
  isCollapsed$ = this.collapsedSubject.asObservable();

  setCollapsed(collapsed: boolean): void {
    this.collapsedSubject.next(collapsed);
  }

  getCollapsed(): boolean {
    return this.collapsedSubject.value;
  }
}
